import React, {useState} from 'react'
import Modal from 'react-bootstrap/Modal'

export const ModalWithTrigger = (props) => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  return (
    <>
      {props.buttonTriggered ?
        <button className='btn btn-large btn-danger' onClick={handleShow}>
          {props.trigger}
        </button> :
        <span className='simulated-link' onClick={handleShow}>
          {props.trigger}
        </span>
      }

      <Modal className='generic-modal-window' show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          {props.title && <Modal.Title>{props.title}</Modal.Title>}
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{__html: props.content}} />
          {props.children}
        </Modal.Body>
      </Modal>
    </>
  )
}
